import { Component, OnInit } from '@angular/core';
import { FormGroup,FormBuilder,Validators,FormControl} from '@angular/forms';
import { AdminService } from '../admin/admin.service';
import { Router,ActivatedRoute } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { AlertService } from '../alert/alert.service';
@Component({
  selector: 'app-admin-login',
  templateUrl: './admin-login.component.html',
  styleUrls: ['./admin-login.component.css'],
})
export class AdminLoginComponent implements OnInit {
  adminLoginFormGroup: FormGroup;
  loginAdminDetails: any;
  submitted = false;
  hideHeaderForAdmin:boolean=false;

  constructor(
    private _formBuilder: FormBuilder,
    private _adminService: AdminService,
    private authService:AuthService,
    private activatedRoute:ActivatedRoute,
    public alertService: AlertService,
    private _route:Router
  ) {}

  ngOnInit(): void {
    this.adminLoginFormGroup = this._formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
      rememberMe: new FormControl(false),
    });
    
  }

  get f() { return this.adminLoginFormGroup.controls; }

  onSubmit() {
  
    this.submitted = true;

    if (this.adminLoginFormGroup.invalid) {
        return;
    }
    const requestData = {
      "email": this.adminLoginFormGroup.value.email,
      "password": this.adminLoginFormGroup.value.password
    } 
    this._adminService.signInAdmin(requestData)
    .subscribe(
        result => {
         this._adminService.saveAdminToken(result.body.token)
         if(result.body.feature_list) {
           sessionStorage.setItem('adminFeatureList', JSON.stringify(result.body.feature_list));
         }
         this.authService.saveAdminInfo();
         if(result.body.token){
          this._route.navigateByUrl('/admin')
          }else{
            this.alertService.error(result.body.error.message);
         }
        },
        error => {
            this.alertService.error(error.error.message);
        }
    ); 
  }
}
